// extracted by mini-css-extract-plugin
module.exports = {"addressItem":"AddressCard_addressItem__2IRms","smText":"AddressCard_smText__970Lk","disableContainer":"AddressCard_disableContainer__V4pdG","marker":"AddressCard_marker__w1Lcj"};